// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".account-menu_accountMenuSkeletonWrapper [data-cs-account-menu-skeleton]{margin:0 -10px 0 -10px}", "",{"version":3,"sources":["webpack://./src/components/account-menu/styles.module.scss"],"names":[],"mappings":"AAGE,yEACE,sBAAA","sourcesContent":["@use '@ciceksepeti/cs-theme/variables.scss' as *;\n\n.accountMenuSkeletonWrapper {\n  [data-cs-account-menu-skeleton] {\n    margin: 0 (-$spacing-10) 0 (-$spacing-10);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accountMenuSkeletonWrapper": "account-menu_accountMenuSkeletonWrapper"
};
export default ___CSS_LOADER_EXPORT___;
